export default "__VITE_ASSET__750479f8__"